module.exports = kolibriGlobal.coreVue.components.BirthYearSelect;